import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { FaBars, FaTimes } from "react-icons/fa";
import { BsFillMoonStarsFill } from "react-icons/bs";

import { ThemeContext } from "../providers/ThemeContext";
import { navBarLinks } from "../config/config";



function Navbar() {

  const [nav, setNav] = useState(false);

  const { darkMode, setDarkMode } = useContext(ThemeContext);

  const navigate = useNavigate();

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  }

  const routeToHome = (e) => {
    let path = `/`;
    navigate(path);
  }

  return (
    <div className={darkMode ? 'dark' : ""}>
      <div className="dark:bg-gray-900">
        <div className="max-w-6xl pt-8 my-0 mx-auto dark:bg-gray-900">
          <div className="flex justify-between items-center w-full h-16 px-4 text-black dark:text-white">
            <div className="cursor-pointer">
              {darkMode ? <img alt="dark logo" onClick={routeToHome} src="https://i.imgur.com/ajxVEM2.png" /> : <img alt="light logo" onClick={routeToHome} src="https://i.imgur.com/cgzYEdJ.png" />}

            </div>
            <div className="flex">
              <ul className="hidden md:flex">
                {navBarLinks.map(({ id, link, route }) => (
                  <li
                    key={id}
                    className="px-4 font-roboto cursor-pointer capitalize font-medium text-gray-500 hover:scale-105 duration-200"
                  >
                    <Link to={"/" + route}>
                      {link}
                    </Link>
                  </li>
                ))}
              </ul>
              <ul>
                <li><BsFillMoonStarsFill onClick={toggleTheme} className='hidden md:block cursor-pointer text-2xl dark:text-gray-400' /></li>
              </ul>
            </div>


            <div
              onClick={() => setNav(!nav)}
              className="cursor-pointer pr-4 z-10 text-gray-500 md:hidden"
            >
              {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
            </div>

            {nav && (
              <ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-black to-gray-800 text-gray-500">
                {navBarLinks.map(({ id, link, route }) => (
                  <li
                    key={id}
                    className="px-4 cursor-pointer capitalize py-6 text-4xl"
                  >
                    <Link
                      onClick={() => setNav(!nav)}
                      to={"/" + route}
                    >
                      {link}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>

  );
}

export default Navbar;